function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.96 32.31c2.115-1.355 3.2-3.024 3.254-5.008.053-1.984-.932-3.623-2.957-4.916l17.665-12.014 18.04 12.205v18.541H9.958V32.31zm6.117-6.798V38.09h7.295V25.512h-7.295z",
  fill: "#A1887F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.325 32.532v8.22h35.27v-17.98l-17.674-11.96-16.864 11.309c1.676 1.671 2.431 3.574 2.244 5.687-.193 2.174-1.19 3.762-2.976 4.724z",
  stroke: "#371447",
  strokeWidth: 0.732
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.566 22.616L27.961 8.186 9.41 20.99c.346.14.615.283.81.431.218.164.557.36 1.011.58L27.87 10.577l19.148 12.948 1.548-.908zm-21.871 1.998h14.27v9.482h-14.27zm-10.118 1.398h6.295V37.59h-6.295zm9.618 13.126h16.237m-32.002 0h4.135m9.513-13.393H15.37v-2.37h8.707m-8.206 14.516h7.706v3.041h-7.706z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.979 11.306l-1 .997h.997l.003-.997zm2.79.997l.661-1h-4.45l-.02 6.755 1.005-1.517.012-4.238h2.792zm-2.79-.997l-1 .997h.997l.003-.997zm2.79.997l.661-1h-4.45l-.02 6.755 1.005-1.517.012-4.238h2.792z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.321 21.167)",
  stroke: "#371447"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.945,
  cy: 6.046,
  rx: 6.083,
  ry: 6.046
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.054 19.95V4.45M6.839 8.7L4.488 7.637m4.488-2.122L6.839 7.213",
  strokeWidth: 0.976
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.549 12.232c.24-.571.813-.539.984-.539.256 0 .497.06.71.167.241-1.503 1.568-2.653 3.17-2.653 1.25 0 2.332.7 2.862 1.723.4-.257.877-.407 1.39-.407 1.401 0 2.537 1.113 2.537 2.487-.014.644-.303 1.146-.865 1.504l-6.389-.043M3.623 41.604h44.959",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.243 26.413l-3.538 3.16m7.441-3.403l-3.537 3.16m3.781 0l-3.537 3.16",
  stroke: "#371447",
  strokeLinecap: "square"
}));

function SvgHomeMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHomeMd;